import React, { useEffect, useState } from "react";
import { axiosNewInstance } from "../../config/Api";
import LangData from "../common/LangData";
import { toast } from "react-hot-toast";

const ServiceRequestList = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [perPage] = useState(10);

    useEffect(() => {
        fetchRequests(currentPage);
    }, [currentPage]);

    const fetchRequests = async (page) => {
        setLoading(true);
        const token = localStorage.getItem("authToken");
        try {
            const response = await axiosNewInstance.get(`/api-app/service-requests?page=${page}&per_page=${perPage}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data.status === 1) {
                const requestData = response.data.data.requests;
                setRequests(requestData.data || []);
                setTotalPages(requestData.last_page || 1);
            }
        } catch (error) {
            console.error("Error fetching service requests:", error);
            toast.error("Failed to load service requests.");
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    return (
        <div className="container-fluid py-4">
            <div className="card shadow-sm">
                <div className="card-header" style={{ backgroundColor: "#004e8f", color: "white" }}>
                    <h5 className="mb-0">
                        <LangData keyname="label_request_list" />
                    </h5>
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th><LangData keyname="label_serial" /></th>
                                    <th><LangData keyname="label_customer_id" /></th>
                                    <th><LangData keyname="label_submitted_by" /></th>
                                    <th><LangData keyname="label_role" /></th>
                                    <th><LangData keyname="label_mobile" /></th>
                                    <th><LangData keyname="label_grievance" /></th>
                                    <th><LangData keyname="label_submitted_date" /></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="7" className="text-center py-4">
                                            <div className="spinner-border text-primary" role="status"></div>
                                        </td>
                                    </tr>
                                ) : requests.length > 0 ? (
                                    requests.map((req, index) => (
                                        <tr key={req.id}>
                                            <td>{index + 1 + (currentPage - 1) * perPage}</td>
                                            <td>{req.user?.emp_id || req.user?.login_id || "N/A"}</td>
                                            <td>
                                                <div>{req.user?.en_first_name || "N/A"}</div>
                                            </td>
                                            <td>{req.user?.role?.name || "N/A"}</td>
                                            <td>{req.user?.mobile || "N/A"}</td>
                                            <td style={{ maxWidth: "300px", whiteSpace: "normal" }}>
                                                {req.grievance_text}
                                            </td>
                                            <td>
                                                {new Date(req.created_at).toLocaleString()}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-muted">
                                            No service requests found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Pagination Controls */}
            {!loading && (
                <div className="d-flex justify-content-between align-items-center mt-3 mb-3 px-3">
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span className="text-muted">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default ServiceRequestList;
